import React from 'react';

import { ECampaignStatus } from '@domain/enums/dashboard/adsManager/ECampaigns';
import { ESynchronizationType } from '@domain/enums/hooks/ESynchronization';

import { useCampaigns } from '@helpers/hooks/pages/dashboard/adsManager/useCampaigns';
import { useSynchronization } from '@helpers/hooks/common/useSynchronization';
import { useToast } from '@helpers/hooks/useToast';

import * as S from './styles';

const ActivateCampaignsModal: React.FC = () => {
  const {
    isActivateCampaignsModalOpen,
    handleActivateCampaignsModalOpen,
    selectedCampaigns,
    onUpdateStatus,
  } = useCampaigns();
  const { currentSynchronizations, synchronizationsQueue } = useSynchronization();
  const { toast } = useToast();

  const parsedCurrentSynchronizations = currentSynchronizations
    ? currentSynchronizations.synchronizations
    : [];
  const mergedSynchronizations = [...parsedCurrentSynchronizations, ...synchronizationsQueue];

  const activateCampaigns = React.useCallback(() => {
    const filteredSynchronizations = mergedSynchronizations.filter(
      synchronization => synchronization.type === ESynchronizationType.ADS_MANAGER_CAMPAIGNS_STATUS,
    );

    const hasActiveSynchronization = selectedCampaigns.find(campaignAliasId => {
      const foundSynchronization = filteredSynchronizations.find(synchronization =>
        synchronization.externalId?.includes(campaignAliasId),
      );

      return Boolean(foundSynchronization);
    });

    if (hasActiveSynchronization) {
      toast.error('Já existe um anúncio sendo atualizado no momento.');
      handleActivateCampaignsModalOpen();
    } else {
      onUpdateStatus(ECampaignStatus.ENABLED, selectedCampaigns);
      handleActivateCampaignsModalOpen();
    }
  }, [
    selectedCampaigns,
    onUpdateStatus,
    handleActivateCampaignsModalOpen,
    mergedSynchronizations,
    toast,
  ]);

  return (
    <S.Modal isOpen={isActivateCampaignsModalOpen} toggle={handleActivateCampaignsModalOpen}>
      <S.Modal.Header>
        <S.Title>Ativar campanhas</S.Title>
      </S.Modal.Header>
      <S.Modal.Body>
        <S.Description>{`Tem certeza em ativar ${selectedCampaigns.length} campanha(s)?`}</S.Description>

        <S.ButtonsWrapper>
          <S.CancelButton type="button" onClick={handleActivateCampaignsModalOpen}>
            Cancelar
          </S.CancelButton>
          <S.ActivateButton onClick={activateCampaigns} type="button">
            Ativar
          </S.ActivateButton>
        </S.ButtonsWrapper>
      </S.Modal.Body>
    </S.Modal>
  );
};

export default ActivateCampaignsModal;
